//library
import React, {useEffect, useState} from "react";
import styled from "styled-components";

//components
import CountDown from "../countDown/CountDown";


const Box = styled.div`

background: 
linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, #1c1c27 100%), 
url("/images/bg.png");
background-size: cover; 
background-repeat: no-repeat; 
background-position: center;



position: relative;
display: flex;
flex-direction: column;
align-items: center;
justify-content: start;
padding: 1em;

  @media (max-width: 768px) {
    gap : 0.7em
  }
`;

// lOGO
const CenterLogo = styled.img`
  width: 40em;

  @media (max-width: 768px) {
    width: 30em;
  }
  @media (max-width: 480px) {
    width: 95%;
    
  }
  @media (max-width: 376px) {
    width: 100%;
    
  }
  @media (max-width: 320px) {
    width: 20em;
  }
`
const OrcesLogo = styled.img`

  width : 7em;
  position : absolute;
  top : 0.5em;
  right : 1em;

  
  @media (max-width: 768px) {
    width:6em;
  }

  @media (max-width: 426px) {
    width:6em;
    
  }

  @media (max-width: 320px) {
    width:5.5em;
    
  }
  
`
const NirmaLogo = styled.img`

  width:10em;
  height:5em;
  position : absolute;
  top : 1em;
  left : 1em;

  
  @media (max-width: 768px) {
    width:8em;
    height:4.5em;
    
  }

   @media (max-width: 426px) {
    width:4em;
    height:2em;
    
  }
    
  @media (max-width: 320px) {
    width:4.5em;
    height:2em;
    
  }

 
`

// Title
const Title = styled.div`
    color : white;
    font-size : 2.5em;
    width : 100%;
    
    font-weight : bold;

    #presents {
      font-size : 1.8rem;

      @media (max-width: 1024px) {
        font-size : 1.4rem;
      }

      @media (max-width: 768px) {
        
      }
      @media (max-width: 426px) {
        font-size : 1.2rem;
      }

      @media (max-width: 320px) {
        font-size : 1rem;
      }

    }

    p{
        text-align : center;

        @media (max-width: 1024px) {
            font-size : 1.6rem;
            
        }

        @media (max-width: 768px) {
            font-size : 1.1rem;
            text-align : center;
  
        }

        @media (max-width: 750px) {
            font-size : 2rem;
            text-align : center;
 
        }
        // @media (max-width: 500px) {
        //     font-size : 1.8rem; 
            
        // }

        @media (max-width: 426px) {
            font-size : 1.3rem;
              
        }

        // @media (max-width: 320px) {
        //     font-size : 0.9rem;
        // }
    }

    span{
    }

    @media (max-width: 768px) {
        
    }

    @media (max-width: 426px) {
        
    }

    @media (max-width: 320px) {
        width:6em;
        
    }
`

const Home = () => {
    const targetDate = new Date('2024-11-08T00:00:00').getTime();
    const [dimension, setDimension] = useState(window.innerWidth);
    
    useEffect(() => {
      // Function to update dimension
      const handleResize = () => {
        setDimension(window.innerWidth);
        
      };

      // Add event listener on component mount
      window.addEventListener('resize', handleResize);

      // Remove event listener on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []); 

    return(
        <Box>

          {dimension > 750 ? (
                  <>
                    <OrcesLogo src = {"images/ORCES.png"} />  
                    <NirmaLogo src = {"images/nirma.png"} />
                  </>
                ) : 
            <>
            <div style={{
              display:"flex",
              justifyContent:"space-between",
              width:"100%",
              marginBottom:"0.2em"

              
            }}>
                
              <img style={{maxHeight: "auto",width:"9em"}} src="images/nirma.png"/>
              <img style={{width:"5em"}} src="images/ORCES.png"/>
            </div>
            
            </>          
          }
      

          <Title>
            <p>
                Organization of Civil Engineering Students
                <br/>of
                <br/>
                Civil Engineering Department,
                <br/>
                ITNU<br/>
                <span id="presents">Presents</span>
                
            </p>          
          </Title>
          <CenterLogo src={"images/Logo3.png"}/>
          


          <CountDown targetDate={targetDate}/>

  
            
          

        </Box>
    );
}

export default Home;